const t = {
  name: "Idea",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 5.00003C13.6577 5.00003 15 6.34232 15 8.00003H17C17 5.23775 14.7623 3.00003 12 3.00003V5.00003Z" fill="currentColor"/>
<path d="M19.9999 8.00002C19.9999 3.05193 15.5173 -0.832948 10.4103 0.158162C7.24321 0.766788 4.73234 3.31617 4.13723 6.47487L4.13662 6.47817C3.54579 9.67299 4.86201 12.6068 7.1413 14.3508L8.2607 18H15.7392L16.859 14.3495C18.7609 12.8877 19.9999 10.5962 19.9999 8.00002ZM10.7906 2.12168C14.6432 1.37351 17.9999 4.28845 17.9999 8.00002C17.9999 10.0365 16.9835 11.8283 15.4256 12.9214L15.1446 13.1186L14.2607 16H9.73918L8.85487 13.1172L8.57212 12.9199C6.72663 11.6323 5.63891 9.35648 6.10296 6.84355C6.54834 4.48334 8.43667 2.5737 10.7885 2.12208L10.7906 2.12168Z" fill="currentColor"/>
<path d="M15 21V19H9V21H15Z" fill="currentColor"/>
<path d="M10 24V22H14V24H10Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Idea
};
